import { render, staticRenderFns } from "./RadiationForm.vue?vue&type=template&id=454a9198&scoped=true&"
import script from "./RadiationForm.vue?vue&type=script&lang=js&"
export * from "./RadiationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a9198",
  null
  
)

export default component.exports